import { duration } from 'moment';
import { pipe } from 'ramda';
import { ofNullable, map, filter, orElse } from 'core/maybe';
import { overrides } from 'translations/en-moment';

export const format = (key: keyof typeof overrides, value: number): string =>
  overrides[key].replace(
    '%d',
    value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  );
// Adding this to always display minutes as well
export const formatterWithMinutes = pipe(
  pipe(
    (minutes: number | string | undefined) => minutes?.toString() ?? null,
    ofNullable,
    map((minutes) => parseInt(minutes, 10)),
    filter((minutes) => !Number.isNaN(minutes)),
    map((minutes) => Math.min(Math.max(minutes, 0))),
    orElse(0),
    (minutes) => duration(minutes, 'minutes'),
    (m) => [duration(Math.floor(m.asHours()), 'hours'), m],
  ),
  ([hours, minutes]) => [hours.asHours(), minutes.subtract(hours).asMinutes()],
  ([h, m]) => [format('hh', h), format('mm', m).padStart(h > 0 ? 3 : 2, '0')],
  (values) => values.join(' ').replace(/^0h /, '').replace(/^00m$/, '0m'),
);

export const formatter = pipe(formatterWithMinutes, (value) =>
  value.replace(/^([\d,]{3,}h) ([\d]{2}m)$/g, '$1'),
);
